export const MEDIA_QUERY = {
  MOBILE_THRESHOLD_WIDTH: 760,
  MOBILE_THRESHOLD_HEIGHT: 800
};

export const IMAGE_OPTIMIZATION_QUERIES = {
  MOBILE: {
    MOBILE: 500,
    TABLET: 768,
    DEKSTOP: 1100
  },
  DESKTOP: {
    WIDE_DESKTOP: 1980
  }
};



// WEBPACK FOOTER //
// ./src/common/consts/media-query.js